import { filesApi } from '../../filesApi'
import { downloadAsZipRequestMapper } from './mapper'
import { ItemsToDownload } from './types'

export async function downloadAsZipRequest({
  itemIds,
  abortController,
  onProgress
}: ItemsToDownload) {
  const response = await filesApi.post(
    '/items/download',
    downloadAsZipRequestMapper(itemIds),
    {
      responseType: 'blob',
      signal: abortController.signal,
      onDownloadProgress: ({ loaded, total }) =>
        total && onProgress?.(Math.round((loaded * 100) / total))
    }
  )

  return new Blob([response.data], { type: 'application/zip' })
}
